<template>
	<div id="app" @click="clicked()">
		<!--<img src="./assets/logo.png">-->
		<router-view/>
	</div>
</template>

<script>
	export default {
		name: 'App',
		data() {
			return {}
		},
		mounted() {
			var that = this
			//设置超时退出
			var lastTime = new Date().getTime();
			var currentTime = new Date().getTime();
			var timeOut = 240 * 60 * 1000; //设置超时时间： 20分
			$(function() {
				/* 鼠标移动事件 */
				$(document).mouseover(function() {
					lastTime = new Date().getTime(); //更新操作时间
				});
			});

			function testTime() {
				currentTime = new Date().getTime(); //更新当前时间
				if(currentTime - lastTime > timeOut) { //判断是否超时
					//this.$message({type: 'info',message: '登陆超时，请重新登陆！'})
					window.sessionStorage.clear();
				}
			}
			/* 定时器  间隔1秒检测是否长时间未操作页面  */
			window.setInterval(testTime, 1000);
		},
		methods: {
			clicked() {
				if(!window.sessionStorage.getItem('id')) {
					this.$router.push({
						path: '/login',
						name: 'Login'
					})
				}
			}

		}
	}
</script>

<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		/*text-align: center;*/
		color: #2c3e50;
		height: 100%;
		padding: 0;
	}
	
	body {
		margin: 0;
		height: 100%;
	}
	
	html {
		height: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/App.vue